import * as React from "react"
import BasePage from "../../base-page"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Link } from "react-router-dom"
import { ToolbarItem } from "../../toolbar"
import { Profile, getProfile } from "../../../domain/sfp/user-domain"
import { LocalAuthority, User, Instruction, BergerlevraultLocalauthority } from "../../../model"
import LocalAuthorityDetail from "../local-authority-detail-page"
import { isBergerLevraultEnabled } from "../../../domain/sfp/berger-levrault-domain"
import { KEY_CURRENT_LOCAL_AUTHORITY } from "../../../util/storage"

export default class budgetAnnexesComponent
	extends BasePage<budgetAnnexesComponentProps, State> {
	protected editingProfiles: Profile[] = this.props.editingProfiles
	protected viewingProfiles: Profile[] = this.props.viewProfiles
	protected toolbar?: ToolbarItem[] = this.getToolbarItems()
	private readonly name: string = "name"
	private readonly cog: string = "cog"
	private readonly connecteur: string = "connecteur"
	private readonly bergerLevrault: string = "Berger Levrault"

	constructor(props){
		super(props)

		this.state = {
			sortedColumn: {
				columnName: "cog",
				order: "asc"
			}
		}
	}

	renderPageContent() {
		const currentUser = this.props.currentUser
		const currentUserProfile = currentUser ? getProfile(currentUser) : null
		const localAuthorities = this.sortLocalAuthorities()

		return <div>
			<table className="table is-narrow">
				<thead>
					<tr>
						<th className="button-header" onClick={() => this.changeColumn(this.cog)}>Code Officiel Géographique</th>
						<th className="button-header" onClick={() => this.changeColumn(this.name)}>Budget annexe</th>
						<th className="button-header"></th>
						<th className="button-header" onClick={() => this.changeColumn(this.connecteur)}>Accès</th>
						<th className="button-header"></th>
						<th className="button-header"></th>
						<th className="button-header"></th>
						{(Profile.LocalAuthorityConsultant !== currentUserProfile
							&& Profile.ServiceAgent !== currentUserProfile) &&
							[<th className="button-column" key={0}></th>]}
					</tr>
				</thead>
				<tbody>
					{localAuthorities.length
						? localAuthorities.map((localAuthority, i) => {
							const loading = this.isLoadingLocalauthority(localAuthority)
							return <tr key={i}>
								<td>{localAuthority.code}</td>
								<td>{localAuthority.name}</td>
								<td>{isBergerLevraultEnabled(localAuthority.bergerLevrault) ? this.bergerLevrault : ""}</td>
								{(Profile.LocalAuthorityConsultant !== currentUserProfile
									&& Profile.ServiceAgent !== currentUserProfile) &&
									[<td key={i}>
										<button
											className={`button is-small ${loading ? "is-loading" : ""}`}
											title={`Voir le détail de la collectivité ${localAuthority.name}`}
											onClick={() => this.props.onClickViewLocalAuthority(localAuthority)}>
											<span className="icon is-small">
												<FontAwesomeIcon icon="pen-square" />
											</span>
										</button>
									</td>]}
								<td key={i+1}>
									{/* <button
										className={`button is-small ${loading ? "is-loading" : ""}`}
										title={`Voir le détail de la collectivité ${localAuthority.name}`}
										onClick={() => this.props.onClickViewLocalAuthorityChild(localAuthority)}
									>
										<span className="icon is-small">
											<FontAwesomeIcon icon="eye" />
										</span>
									</button> */}

									<Link to={"#"} className="button"  onClick={() => { localStorage.setItem(KEY_CURRENT_LOCAL_AUTHORITY, localAuthority.id.toString()); window.open( `/${localAuthority.slug}`)}} target="_blank">
										<span className="icon is-small">
											<FontAwesomeIcon icon="eye" />
										</span></Link>
								</td>
								<td></td>
							</tr>
						})
						: <tr><td colSpan={5}>Aucune collectivité enregistrée</td></tr>}
				</tbody>
			</table>

			{this.props.viewLocalAuthority &&
				<LocalAuthorityDetail
					localAuthority={this.props.localAuthority}
					onClose={this.props.onCloseEditLocalAuthority}
					onLocalAuthorityUpdated={this.props.onLocalAuthorityUpdated}
					updatePA={(l)=>this.props.onLocalAuthorityUpdatedPA(l)} />}

		</div>
	}




	private changeColumn(columnName: string): void {
		let order, newSortedColumn
		const actualSortedColumn = this.state.sortedColumn
		const orderAsc = actualSortedColumn.order === 'asc' ? order = 'desc' : order = 'asc'
		actualSortedColumn.columnName === columnName && actualSortedColumn.order === order ? order = !order : orderAsc
		newSortedColumn = {	columnName, order }
		this.setState({ sortedColumn: newSortedColumn })
	}



	private getToolbarItems(): ToolbarItem[] {
		const items: ToolbarItem[] = []
		// items.push({
		// 	allowedProfiles: [
		// 		Profile.SuperAdmin,
		// 		Profile.RegionAdmin,
		// 		Profile.LocalAuthorityAdmin
		// 	],
		// 	icon: "user-plus",
		// 	text: "Ajouter une collectivité",
		// 	title: "Ajouter une collectivité",
		// 	onClick: this.props.onClickAddLocalAuthority
		// })
		return items
	}

	private sortLocalAuthorities() {
		let users
		const sortedColumn = this.state.sortedColumn
		const columnName = sortedColumn.columnName
		if (columnName === this.name) users = this.filteringName()
		if (columnName === this.cog) users = this.filteringCog()
		return users
	}

	private filteringName() {
		const localAuthorities = this.props.localAuthorities
		const sortedColumn = this.state.sortedColumn
		let filtering = sortedColumn.order === 'asc' ? 1 : -1

		let sortedLocalauthorities = localAuthorities.filter((l, index) => localAuthorities.lastIndexOf(l) === index)
			.sort((a, b) => (a.name.toUpperCase() < b.name.toUpperCase() ? -1 : 1) * filtering)
		return sortedLocalauthorities
	}

	private filteringCog() {
		const localAuthorities = this.props.localAuthorities
		const sortedColumn = this.state.sortedColumn
		let filtering = sortedColumn.order === 'asc' ? 1 : -1

		let sortedLocalauthorities = localAuthorities.filter((l, index) => localAuthorities.lastIndexOf(l) === index)
			.sort((a, b) => (a.code < b.code ? -1 : 1) * filtering)
		return sortedLocalauthorities
	}

	private isLoadingLocalauthority(localAuthority: LocalAuthority) {
		return !!this.props.editingLocalAuthorities.find(l => l.id === localAuthority.id) || false
	}
}


interface State {
	sortedColumn: {
		columnName: "name" | "cog",
		order: "asc" | "desc"
	}
}

export enum Names {
	Name = "local-authority-list-name",
	Cog = "local-authority-list-cog",
}

export interface budgetAnnexesComponentProps {
	selectedSlug: string
	addChildLocalAuthority: boolean
	addLocalAuthority: boolean
	currentUser: User
	editingLocalAuthorities: LocalAuthority[]
	editingProfiles: Profile[]
	instructions: Instruction[]
	loading: boolean
	loadingInstructions: boolean
	localAuthorities: LocalAuthority[]
	currentLocalAuthority: LocalAuthority
	localAuthoritiesChildren: LocalAuthority[]
	localAuthority: LocalAuthority
	viewLocalAuthority: boolean
	editExtraLocalAuthority: boolean
	viewProfiles: Profile[]
	viewingLocalAuthoritiesChildren: boolean
	onClickViewLocalAuthorityChild(localAuthority: LocalAuthority): void
	onClickAddChildLocalAuthority(localAuthority: LocalAuthority): void
	onClickAddLocalAuthority(e: React.SyntheticEvent<Element>): void
	onClickViewLocalAuthority(localAuthority: LocalAuthority): void
	onLocalAuthorityUpdatedPA(localAuthority: LocalAuthority): void
	onCloseEditLocalAuthority(): void
	onLocalAuthorityUpdated(): void
}


// WEBPACK FOOTER //
// ./src/component/page/budgetsAnnexe/budgets-annexes.tsx